import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postDuplicateVisualValidationComparison = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  dataObjectVersion1Id: number;
  dataObjectVersion2Id: number;
}) =>
  apiClient
    .post<{
      externalCode: string;
    }>(
      expand(ValidationDashboardUrl.COMPARISON_DUPLICATE, { externalCode }),
      data,
    )
    .then((response) => response.data);

export const useDuplicateVisualValidationComparisonMutation =
  createApiMutationHook(
    ['duplicateVisualValidationComparison'],
    postDuplicateVisualValidationComparison,
  );
